import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_VERSION, URL_BASE } from '../../core/constants';

@Injectable()
export class AppversionInterceptorService implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.startsWith(URL_BASE)) {
      request = request.clone({
        setHeaders: {
          'X-Consumer-Version': 'CMAWEB-' + APP_VERSION
        }
      });
    }

    return next.handle(request);
  }
}
